import React from "react";
import "./FleetCoreRealFleetOperations.css";

import fleetcoreRealFleetOperationsPhotoJpg from "../../images/fleetcore-real-fleet-operations-mine-access.jpg";
import fleetcoreRealFleetOperationsPhotoWebp from "../../images/fleetcore-real-fleet-operations-mine-access.webp";
import fleetcoreRealFleetOperationsEvidenceCard from "../../images/fleetcore-real-fleet-operations-evidence-card.svg";

export default function FleetCoreRealFleetOperations() {
  return (
    <section className="fleetcore-real-fleet-operations" id="fleetcore-real-operations" aria-labelledby="fleetcore-real-fleet-operations-title">
      <div className="fleetcore-real-fleet-operations__inner">
        <div className="fleetcore-real-fleet-operations__copy">
          <p className="fleetcore-real-fleet-operations__eyebrow">REAL OPERATIONS, REAL EVIDENCE</p>
          <h2 id="fleetcore-real-fleet-operations-title">Built for fleets that work beyond the office.</h2>
          <p className="fleetcore-real-fleet-operations__body">From mine sites and regional depots to delivery and service fleets, FleetCore captures evidence where the work happens—on the driver's phone, at the vehicle and during the shift.</p>
          <div className="fleetcore-real-fleet-operations__tags"><span>Remote sites</span><span>Mixed assets</span><span>Shift teams</span></div>
          <p className="fleetcore-real-fleet-operations__principle">Mobile-first capture. Centralised accountability.</p>
        </div>
        <div className="fleetcore-real-fleet-operations__visual">
          <picture><source srcSet={fleetcoreRealFleetOperationsPhotoWebp} type="image/webp" /><img src={fleetcoreRealFleetOperationsPhotoJpg} alt="Fleet driver completing a mobile identity check-in beside a commercial bakkie at a South African mine access point" /></picture>
          <img className="fleetcore-real-fleet-operations__evidence" src={fleetcoreRealFleetOperationsEvidenceCard} alt="FleetCore mine-access evidence card linking driver, vehicle and access event" />
        </div>
      </div>
    </section>
  );
}